
    <template>
    <div>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_user_reports" autocomplete="off">
                <v-layout row wrap>
            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="reports" v-model="user_reports.report_id" outlined  item-text="report_id"
                            item-value="report_id" :return-object="false" :label="$store.getters.lang.data.report_id">
                        </v-select>
                        </v-flex>
            
            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="users" v-model="user_reports.user_id" outlined  item-text="user_id"
                            item-value="user_id" :return-object="false" :label="$store.getters.lang.data.user_id">
                        </v-select>
                        </v-flex>
            
        <v-flex xs12 lg2 xl2 md3 sm4>
        <v-text-field v-model="user_reports.report_date" type="date" :label="$store.getters.lang.data.report_date" outlined
            class="mx-1"  required rounded>
        </v-text-field>
    </v-flex>


    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large >{{$store.getters.lang.data.add_btn}} user_reports</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                        {{$store.getters.lang.data.user_reports}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="user_report_id">
                                <template v-slot:[`item.user_report_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_user_reports(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/user_reports-list/'+item.user_report_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                    {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_user_reports(selected_user_reports.user_report_id)">
                    {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/user_reports'
    export default {
        data() {
            return {
                user_reports: {},
                search: '',
                loading : true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_user_reports: {},
                delete_dialog: false,
                headers: [
                    
        {
            text: this.$store.getters.lang.data.user_report_id,
            align: 'start',
            sortable: true,
            value: 'user_report_id',
        },


        {
            text: this.$store.getters.lang.data.report_id,
            align: 'start',
            sortable: true,
            value: 'report_id',
        },


        {
            text: this.$store.getters.lang.data.user_id,
            align: 'start',
            sortable: true,
            value: 'user_id',
        },


        {
            text: this.$store.getters.lang.data.report_date,
            align: 'start',
            sortable: true,
            value: 'report_date',
        },


                ],
            }
        },
        computed: {
            rows(){
                return this.$store.getters.user_reports
            },
            
                    reports (){
                        return this.$store.getters.reports
                    },
                    
                    users (){
                        return this.$store.getters.users
                    },
                    
            
        },
        mounted(){
            this.read_user_reports();
        },
        methods: {
            add_user_reports() {
                controller.add_user_reports(this.user_reports).then(r => {
                    if (r.data) {
                        this.user_reports = {}
                        this.$store.state.user_reports.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'user_reports Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add user_reports',
                            color: 'error'
                        }
                    }
                })
            },
            delete_user_reports(user_report_id) {
                controller.delete_user_reports(user_report_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.user_reports = this.$store.state.user_reports.filter(f =>{
                            return f.user_report_id != user_report_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'user_reports Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_user_reports() {
                this.loading = true
                controller.get_user_reports().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_user_reports(i) {
                this.selected_user_reports = i
                this.delete_dialog = true
            },
        },
    }
</script>
